import { Injectable } from '@angular/core';
import { MessageModalButtons, MessageModalDisplayMode, MessageModalOptions, MessageModalResult, MessageModalService } from './messageModal.service';

/**
 * @deprecated Use MessageModalButtons and MessageModalService instead
 */
export enum MessageBoxButtons {
    OK = 1,
    OKCancel = 2,
    YesNo = 3,
    YesNoCancel = 4
}

/**
 * @deprecated Use MessageModalResult and MessageModalService instead
 */
export enum MessageBoxResult {
    OK = 1,
    Cancel = 2,
    Yes = 3,
    No = 4
}

/**
 * @deprecated Use MessageModalOptions and MessageModalService instead
 */
export interface MessageBoxOptions {
    title?: string,
    message: string,
    buttons: MessageBoxButtons,
    focusButton?: MessageBoxResult
}

/**
 * @deprecated Use MessageModalService instead
 */
@Injectable({ providedIn: 'root' })
export class MessageBoxService {
    constructor(private readonly _messageModalService: MessageModalService) {}

    async open(options: MessageModalOptions | MessageBoxOptions, isBackdropStatic?: boolean): Promise<MessageBoxResult> {
        try {
            const modifiedOptions = { ...options, ...{
                displayMode: MessageModalDisplayMode.SingleMessage
                }
            } as MessageModalOptions;
            await this._messageModalService.open((modifiedOptions as MessageModalOptions), isBackdropStatic);
            switch (options.buttons) {
                case MessageModalButtons.YesNo:
                case MessageModalButtons.YesNoCancel:
                    return MessageBoxResult.Yes;
                case MessageModalButtons.OKCancel:
                    return MessageBoxResult.OK;
                default:
                    return MessageBoxResult.OK;
            }
        } catch (err) {
            switch (options.buttons) {
                case MessageModalButtons.YesNo:
                    return MessageBoxResult.No;
                case MessageModalButtons.OKCancel:
                case MessageModalButtons.YesNoCancel:
                    return MessageBoxResult.Cancel;
                default:
                    return MessageBoxResult.OK;
            }
        }
    }

    confirm(message: string, title?: string, focusButton?: MessageModalResult): Promise<void> {
        return this._messageModalService.confirm(message, title, focusButton);
    }

    confirmYesNo(message: string, title?: string): Promise<void> {
        return this._messageModalService.confirmYesNo(message, title);
    }

    warning(message: string, title?: string): Promise<void> {
        return this._messageModalService.warning(message, title);
    }
}

@Injectable({ providedIn: 'root' })
export class MessageBoxExtensionService {
    constructor(private readonly _messageModalService: MessageModalService) {}

    async open(options: MessageModalOptions | MessageBoxOptions, isBackdropStatic?: boolean): Promise<MessageBoxResult> {
        const modifiedOptions = {
            ...options,
            ...{
                displayMode: MessageModalDisplayMode.SingleMessage,
            },
        } as MessageModalOptions;

        const result = await this._messageModalService.openWithResult(modifiedOptions, isBackdropStatic);

        switch (result) {
            case MessageModalResult.Yes:
                return MessageBoxResult.Yes;
            case MessageModalResult.No:
                return MessageBoxResult.No;
            case MessageModalResult.Cancel:
                return MessageBoxResult.Cancel;
            case MessageModalResult.OK:
            default:
                return MessageBoxResult.OK;
        }
    }
}
